import { __assign } from "tslib";
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { iconButtonMarginRightPixels, iconMaxHeightPixels, squareButtonSizePixels, } from './constants';
export var useActionMenuTriggerStyles = makeStyles({
    button: __assign(__assign({ backgroundColor: tokens.colorTransparentBackground, maxHeight: squareButtonSizePixels }, shorthands.borderRadius(tokens.borderRadiusMedium)), { marginRight: iconButtonMarginRightPixels, ':focus-visible': {
            outlineWidth: '2px',
            outlineStyle: 'solid',
            outlineColor: tokens.colorStrokeFocus2,
            outlineOffset: '0px',
        } }),
    icon: {
        height: iconMaxHeightPixels,
        maxHeight: iconMaxHeightPixels,
        width: iconMaxHeightPixels,
        maxWidth: iconMaxHeightPixels,
    },
});
//# sourceMappingURL=ActionMenuTrigger.styles.js.map